import styled from "styled-components";
import { Button as AntButton } from "antd";

export const RootContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 34px 16px;
`;

export const ShareItemsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 50px;
  width: 100%;
`;

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 93%;
  background: #F2E7F7;
  border-radius: 20px;
  padding: 34px 16px 16px 16px;
`;

export const Title = styled.div`
  background: linear-gradient(180deg, #9027e1 0%, #58297b 104.12%);
  color: #fff;
  position: absolute;
  top: -15px;
  border-radius: 8px;
  padding: 8px 34px;
  font-weight: 400;
  font-size: 14px;
`;

export const PointContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-top: 16px;
`;

export const Point = styled.div`
  color: #000;
  font-size: 12px;
  font-weight: 400;
`;

export const Collect = styled(AntButton)`
  background: linear-gradient(180deg, #9027E1 0%, #58297B 104.12%);
  padding: 8px;
  border-radius: 8px;
  border: none !important;

  color: #fff !important;
  font-size: 10px;
  font-weight: 400;

  cursor: pointer;

  :disabled {
    background: lightgray !important;
    color: gray !important;

    :hover {
    color: gray !important;
    }
  }

  :hover {
    border: none !important;
    color: #fff !important;
  }
`;

export const Divider = styled.div`
  width: 100%;
  background: #EAD4FF;
  height: 1px;
  margin: 16px 0px;
`;

export const SeeMore = styled.div`
  color: #9027E1;
  font-size: 12px;
  font-weight: 500;

  cursor: pointer;
`;

export const StepsContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 112%;
  margin-left: 12%;
`;

export const StepBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 25%;
`;

export const IconBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 30px;

  position: relative;
`;

export const Number = styled.p`
  width: 25px;

  color: #000;
  text-align: center;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

export const FinishLine = styled.div`
  height: 4px;
  background-color: #611BA5;
  width: ${(props) => props.width === 0 ? '0px' 
  : props.width === 100 ? `calc(${props.width}% - 28px)`
  : `calc(${props.width}% - ${props.width * 14 / 100}%)`};
`;

export const UnfinishLine = styled.div`
  height: 2px;
  background-color: #E5A7FF;
  width: ${(props) =>
    props.width === 100 ? `calc(${props.width}% - 20px)` 
    : props.width === 0 ? '0px'
    : `calc(${props.width}% - ${props.width * 14 / 100}%)`};
`;

export const CurrentMilestone = styled.p`
  position: absolute;
  top: 0;
  right: calc(50% - 20px);

  color: #000;
  font-size: 8px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

export const CollectModalTitle = styled.div`
  margin-bottom: 10px;
  color: #fff;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;

export const CollectModalQuestion = styled.div`
  display: block;

  color: #fff;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
`;

export const Loader = styled.div`
	width: 100%;
	height: calc(100vh - 68px);
	display: flex;
	align-items: center;
	justify-content: center;
`;

export const EmptyBox = styled.div`
	width: 100%;
	height: calc(100vh - 70px);
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
`;

export const NoResultText = styled.div`
	padding-top: 16px;
	font-size: 16px;
	font-style: normal;
	font-weight: 400;
	line-height: normal;
	color: #5D5189;
`;

export const ShareItemBottomContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`

export const ShareAndCopyContaier = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  column-gap: 12px;
`

export const CopyCotainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  cursor: pointer;
`

export const BottomText = styled.p`
  color: #4F5C64;
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`

export const ShareContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  cursor: pointer;
`
